// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpDataGrid, jpDataGridCell, jpDataGridRow } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
// WARNING The wrapping needs to be called in order (from bottom to top DOM elements)
// Otherwise during the wrapping the tag for sub elements won't be resolved and this
// will contaminate the standard web component.
export const DataGridCell = wrap(jpDataGridCell(), {
    events: { onFocus: 'cell-focused' }
});
// @ts-expect-error unknown property
DataGridCell.displayName = 'Jupyter.DataGridCell';
export const DataGridRow = wrap(jpDataGridRow(), { events: { onFocus: 'row-focused' } });
// @ts-expect-error unknown property
DataGridRow.displayName = 'Jupyter.DataGridRow';
export const DataGrid = wrap(jpDataGrid());
// @ts-expect-error unknown property
DataGrid.displayName = 'Jupyter.DataGrid';
